"use strict";

var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IncrementalMerkleTree = void 0;
var Base_1 = __importDefault(require("./Base"));
var treeify_1 = __importDefault(require("treeify"));
var IncrementalMerkleTree = /*#__PURE__*/function (_Base_1$default) {
  _inherits(IncrementalMerkleTree, _Base_1$default);
  function IncrementalMerkleTree(hashFn, options) {
    var _this;
    _classCallCheck(this, IncrementalMerkleTree);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IncrementalMerkleTree).call(this));
    _this.hashFn = hashFn;
    if (options.depth) {
      _this.depth = options.depth;
    }
    if (options.arity) {
      _this.arity = options.arity;
    }
    if (_this.depth < 1) {
      throw new Error('depth must be greater than 0');
    }
    if (_this.arity < 1) {
      throw new Error('arity must be greater than 0');
    }
    var nodes = [];
    var zeroValue = options.zeroValue;
    _this.zeroValue = zeroValue;
    _this.zeroes = [];
    if (_this.depth) {
      for (var i = 0; i < _this.depth; i++) {
        _this.zeroes.push(zeroValue);
        nodes[i] = [];
        zeroValue = _this.hashFn(Array(_this.arity).fill(zeroValue));
      }
    }
    _this.nodes = nodes;
    _this.root = zeroValue;
    return _this;
  }
  _createClass(IncrementalMerkleTree, [{
    key: "getRoot",
    value: function getRoot() {
      return this.root;
    }
  }, {
    key: "getHexRoot",
    value: function getHexRoot() {
      return this.bufferToHex(this.bufferify(this.getRoot()));
    }
  }, {
    key: "insert",
    value: function insert(leaf) {
      if (this.depth && this.arity) {
        if (this.nodes[0].length >= this.getMaxLeaves()) {
          throw new Error('tree is full');
        }
      }
      var node = leaf;
      var index = this.nodes[0].length;
      for (var level = 0; level < this.depth; level += 1) {
        var position = index % this.arity;
        var levelStartIndex = index - position;
        var levelEndIndex = levelStartIndex + this.arity;
        var children = [];
        this.nodes[level][index] = node;
        for (var i = levelStartIndex; i < levelEndIndex; i += 1) {
          if (i < this.nodes[level].length) {
            children.push(this.nodes[level][i]);
          } else {
            children.push(this.zeroes[level]);
          }
        }
        node = this.hashFn(children);
        index = Math.floor(index / this.arity);
      }
      this.root = node;
    }
  }, {
    key: "delete",
    value: function _delete(index) {
      this.update(index, this.zeroValue);
    }
  }, {
    key: "update",
    value: function update(index, newLeaf) {
      if (index < 0 || index >= this.nodes[0].length) {
        throw new Error('out of bounds');
      }
      var node = newLeaf;
      for (var level = 0; level < this.depth; level += 1) {
        var position = index % this.arity;
        var levelStartIndex = index - position;
        var levelEndIndex = levelStartIndex + this.arity;
        var children = [];
        this.nodes[level][index] = node;
        for (var i = levelStartIndex; i < levelEndIndex; i += 1) {
          if (i < this.nodes[level].length) {
            children.push(this.nodes[level][i]);
          } else {
            children.push(this.zeroes[level]);
          }
        }
        node = this.hashFn(children);
        index = Math.floor(index / this.arity);
      }
      this.root = node;
    }
  }, {
    key: "getDepth",
    value: function getDepth() {
      return this.depth;
    }
  }, {
    key: "getArity",
    value: function getArity() {
      return this.arity;
    }
  }, {
    key: "getMaxLeaves",
    value: function getMaxLeaves() {
      return Math.pow(this.depth, this.arity);
    }
  }, {
    key: "indexOf",
    value: function indexOf(leaf) {
      return this.nodes[0].indexOf(leaf);
    }
  }, {
    key: "getLeaves",
    value: function getLeaves() {
      var leaves = this.copyList(this.nodes[0]);
      var index = this.nodes[0].length;
      for (var i = index; i < this.getMaxLeaves(); i++) {
        leaves[i] = this.zeroValue;
      }
      return leaves;
    }
  }, {
    key: "copyList",
    value: function copyList(list) {
      return list.map(function (x) {
        return BigInt(x);
      });
    }
  }, {
    key: "getLayers",
    value: function getLayers() {
      var layers = [];
      var _iterator = _createForOfIteratorHelper(this.nodes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var list = _step.value;
          layers.push(this.copyList(list));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (layers[0].length < this.getMaxLeaves()) {
        var index = layers[0].length;
        for (var i = index; i < this.getMaxLeaves(); i++) {
          layers[0][i] = this.zeroValue;
        }
        for (var level = 0; level < this.depth; level++) {
          var position = index % this.arity;
          var levelStartIndex = index - position;
          var levelEndIndex = levelStartIndex + this.arity;
          for (var _i = levelStartIndex; _i < levelEndIndex; _i++) {
            if (_i >= layers[level].length) {
              layers[level][_i] = this.zeroes[level];
            }
          }
          index = Math.floor(index / this.arity);
        }
      }
      layers.push([this.root]);
      return layers;
    }
  }, {
    key: "getHexLayers",
    value: function getHexLayers() {
      var _this2 = this;
      return this.getLayers().reduce(function (acc, item) {
        if (Array.isArray(item)) {
          acc.push(item.map(function (layer) {
            return _this2.bufferToHex(_this2.bufferify(layer));
          }));
        } else {
          acc.push(item);
        }
        return acc;
      }, []);
    }
  }, {
    key: "getLayersAsObject",
    value: function getLayersAsObject() {
      var _this3 = this;
      var layers = this.getLayers().map(function (layer) {
        return layer.map(function (value) {
          return _this3.bufferToHex(_this3.bufferify(value), false);
        });
      });
      var objs = [];
      for (var i = 0; i < layers.length; i++) {
        var arr = [];
        for (var j = 0; j < layers[i].length; j++) {
          var obj = _defineProperty({}, layers[i][j], null);
          if (objs.length) {
            obj[layers[i][j]] = {};
            var a = objs.shift();
            var akey = Object.keys(a)[0];
            obj[layers[i][j]][akey] = a[akey];
            if (objs.length) {
              var b = objs.shift();
              var bkey = Object.keys(b)[0];
              obj[layers[i][j]][bkey] = b[bkey];
            }
          }
          arr.push(obj);
        }
        objs.push.apply(objs, arr);
      }
      return objs[0];
    }
  }, {
    key: "computeRoot",
    value: function computeRoot() {
      var node;
      var index = this.nodes[0].length;
      for (var level = 0; level < this.depth; level += 1) {
        var position = index % this.arity;
        var levelStartIndex = index - position;
        var levelEndIndex = levelStartIndex + this.arity;
        var children = [];
        for (var i = levelStartIndex; i < levelEndIndex; i += 1) {
          if (i < this.nodes[level].length) {
            children.push(this.nodes[level][i]);
          } else {
            children.push(this.zeroes[level]);
          }
        }
        node = this.hashFn(children);
        index = Math.floor(index / this.arity);
      }
      return node;
    }
  }, {
    key: "getProof",
    value: function getProof(index) {
      if (index < 0 || index >= this.nodes[0].length) {
        throw new Error('The leaf does not exist in this tree');
      }
      var siblings = [];
      var pathIndices = [];
      var leafIndex = index;
      for (var level = 0; level < this.depth; level += 1) {
        var position = index % this.arity;
        var levelStartIndex = index - position;
        var levelEndIndex = levelStartIndex + this.arity;
        pathIndices[level] = position;
        siblings[level] = [];
        for (var i = levelStartIndex; i < levelEndIndex; i += 1) {
          if (i !== index) {
            if (i < this.nodes[level].length) {
              siblings[level].push(this.nodes[level][i]);
            } else {
              siblings[level].push(this.zeroes[level]);
            }
          }
        }
        index = Math.floor(index / this.arity);
      }
      return {
        root: this.root,
        leaf: this.nodes[0][leafIndex],
        pathIndices: pathIndices,
        siblings: siblings
      };
    }
  }, {
    key: "verify",
    value: function verify(proof) {
      var node = proof.leaf;
      for (var i = 0; i < proof.siblings.length; i += 1) {
        var children = proof.siblings[i].slice();
        children.splice(proof.pathIndices[i], 0, node);
        node = this.hashFn(children);
      }
      return proof.root === node;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.toTreeString();
    }
  }, {
    key: "toTreeString",
    value: function toTreeString() {
      var obj = this.getLayersAsObject();
      return treeify_1.default.asTree(obj, true);
    }
  }]);
  return IncrementalMerkleTree;
}(Base_1.default);
exports.IncrementalMerkleTree = IncrementalMerkleTree;
if (typeof window !== 'undefined') {
  ;
  window.IncrementalMerkleTree = IncrementalMerkleTree;
}
exports.default = IncrementalMerkleTree;